import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/storage";
import "@firebase/firestore";
import "@firebase/functions";
import _ from "lodash";
import env from "./env";

firebase.initializeApp(env.firebase);

const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();
const functions = firebase.functions();
// const functions = firebase.app().functions("europe-west");

const docsFromSnapshot = snapshot =>
  _.reduce(
    snapshot.docs,
    (docs, doc) => ({
      ...docs,
      [doc.id]: {
        _id: doc.id,
        ...doc.data()
      }
    }),
    {}
  );

const docFromSnapshot = snapshot => {
  const data = snapshot.data();
  return !data || data.deleted
    ? null
    : {
      _id: snapshot.id,
      ...data
    };
};

export {
  auth,
  db,
  storage,
  functions,
  docsFromSnapshot,
  docFromSnapshot
};
